if (
  process.env.CVNA_APIK_BASE_URL == null ||
  process.env.CVNA_APP_CDN_URL == null ||
  process.env.CVNA_K8S_BASE_URL == null
) {
  throw new Error('Base URL environment variable(s) missing.');
}

export const APIK_BASE_URL = process.env.CVNA_APIK_BASE_URL;
export const CVNA_APP_CDN_URL = process.env.CVNA_APP_CDN_URL;
export const K8S_BASE_URL = process.env.CVNA_K8S_BASE_URL;

// Endpoints reached server-side via K8s apps ingress (edge/*, some merch-platform routes, etc.) must
// resolve through K8S_BASE_URL — not an APIM or analytics-gateway host; getting this wrong has caused hotfixes before.
export const REFRESH_TOKEN = `${K8S_BASE_URL}/core/userorchestrator/api/v1/account/refresh-token`;

export const BASELINE = `${K8S_BASE_URL}/merch/search/api/v2/search/baseline`;

export const GET_DELIVERY_PICKUP = `${K8S_BASE_URL}/merch/buffering/api/v1/soonestavailabilitybulk`;

export const VEHICLE_PRICING = `${K8S_BASE_URL}/merch/search/api/v2/pricing/vehicle`;
export const APIK_VEHICLE_PRICING = `${APIK_BASE_URL}/merch/search/api/v2/pricing/vehicle`;

export const WHY_BUY = `${K8S_BASE_URL}/merch/vehicledetails/api/v1/whybuy`;

export const APPS_INVENTORY = `${K8S_BASE_URL}/merch/search/api/v2/search`;
export const APPS_OPEN_PERSONALIZED_RECS = `${K8S_BASE_URL}/merch/search/api/v1/recommendations/open-personalized-recs`;
export const APPS_PERSONALIZED_RECS = `${K8S_BASE_URL}/merch/search/api/v1/recommendations/personalized-recs`;
export const DEALERSHIP_INVENTORY = `${K8S_BASE_URL}/merch/search/api/v2/search/dealership`;

export const APPS_FACETS = `${K8S_BASE_URL}/merch/search/api/v2/search/facets`;
export const DEALERSHIP_FACETS = `${K8S_BASE_URL}/merch/search/api/v2/search/facets/dealership`;

export const APPS_CATEGORIES = `${K8S_BASE_URL}/merch/search/api/v2/search/categories`;
export const APIK_CATEGORIES = `${APIK_BASE_URL}/merch/search/api/v2/search/categories`;

export const PRICING_AGGREGATES = `${APIK_BASE_URL}/merch/search/api/v2/pricing/aggregates`;

export const DEVICE_DETECTION = `${K8S_BASE_URL}/edge/devicedetection/api/v1/devicedetection`;

export const DISPLAYABLE_AQUISITION = `${K8S_BASE_URL}/stc/gatewayapi/v1/graphql`;

export const DISCOUNTS = `${K8S_BASE_URL}/oec/purchasediscounts/api/v1/Discounts`;

export const GEOLOCATION = `${K8S_BASE_URL}/edge/geolocation/api/v1/geolocation`;
export const GEOLOCATION_V2 = `${K8S_BASE_URL}/edge/geolocation/api/v2/geolocation`;

export const WEB_EVENTABLE = `${K8S_BASE_URL}/edge/web-eventable/api/graph`;

export const JWKS = `${K8S_BASE_URL}/edge/authserver/.well-known/openid-configuration/jwks`;

export const DELIVERY_CONTEXT = `${K8S_BASE_URL}/merch/carvanamerchcontextapi/api/v3/delivery`;

export const LOCATION_INFORMATION_FROM_ZIP = `${K8S_BASE_URL}/merch/carvanamerchcontextapi/api/v2/delivery/location`;

export const VEHICLE_AVAILABILITY = `${K8S_BASE_URL}/merch/vehicledetails/api/v1/availability`;

export const VEHICLE_DETAILS = `${K8S_BASE_URL}/merch/vehicles/api/v1/graphql/`;

export const HOME_INTERNAL_LINKS = `${K8S_BASE_URL}/seo/internallinksapi/api/links/v2/byurl/cars`;

export const GET_COSMOS_DB_VEHICLE_IDS = `${K8S_BASE_URL}/merch/merchtoolsapi/api/v1/vehiclequery`;

export const GET_DEVICE_LAST_ACTION = `${K8S_BASE_URL}/merch/rcbapi/api/v1/rcb/devicelastaction`;
export const GET_USER_LAST_ACTION = `${K8S_BASE_URL}/merch/rcbapi/api/v1/rcb/userlastaction`;

export const GET_DEVICE_RECENT_SEARCH = `${K8S_BASE_URL}/merch/rcbapi/api/v1/rcb/devicerecentsearches`;
export const GET_USER_RECENT_SEARCH = `${K8S_BASE_URL}/merch/rcbapi/api/v1/rcb/userrecentsearches`;

export const GET_DEVICE_RECENT_VEHICLES = `${K8S_BASE_URL}/merch/rcbapi/api/v1/rcb/deviceviews`;

export const GET_TRADE_IMAGE = `${K8S_BASE_URL}/vex/bluesteel/api/best_available_stock_image`;

export const GET_OWNER_REVIEWS = `${K8S_BASE_URL}/merch/reviews/api/review/sv`;
export const GET_TRAFFIC_REVIEWS = `${K8S_BASE_URL}/seo/reviews-api/api/reviews/v4`;

export const SCE_LOCATION_SERVICE_GQL = `${K8S_BASE_URL}/sce/locationservice/graphql/`;

export const FORCE_BUCKET = `${K8S_BASE_URL}/edge/splittest/api/v3/identifier/chosen-bucket`;

export const getAutoCheckIframe = (isLocal: boolean) =>
  `${
    isLocal ? 'https://localhost.carvanatech.com' : APIK_BASE_URL
  }/merch/merchui/api/v1/autocheck`;

export const VANITY_URLS = `${CVNA_APP_CDN_URL}/resolution/resolution.json`;

export const ZIP_CODES = `${CVNA_APP_CDN_URL}/merchui/zip_codes.txt`;

export const HYGRAPH_CMS =
  'https://api-us-west-2.hygraph.com/v2/ckzrp71yg15q801wc3x16efkm/master';

export const SOFTPULL_UPDATE = `${APIK_BASE_URL}/fin/softpull/api/v1/applicants/self/update-soft-pull`;

export const FINANCING_ADAPTER_GRAPHQL = `${K8S_BASE_URL}/oec/financingadapter/graphql/`;
export const FINANCING_ADAPTER_TOGGLE_COAPPLICANT = `${K8S_BASE_URL}/oec/financingadapter/api/v1/creditapplication/toggle-coapplicant`;

const MERCH_UI_API_BASE_URL = `${
  process.env.IS_LOCAL ? 'https://localhost.carvanatech.com' : APIK_BASE_URL
}/merch/merchui`;

export const MERCH_UI_CREDIT_APPLICATION = `${MERCH_UI_API_BASE_URL}/api/v1/credit-application`;
export const MERCH_UI_CREDIT_STATUS = `${MERCH_UI_API_BASE_URL}/api/v1/credit-status`;
export const MERCH_UI_RECENT_SEARCHES = `${MERCH_UI_API_BASE_URL}/api/v1/recentsearches`;
export const MERCH_UI_TOGGLE_COAPPLICANT = `${MERCH_UI_API_BASE_URL}/api/v1/toggle-coapplicant`;
export const MERCH_UI_TRADES = `${MERCH_UI_API_BASE_URL}/api/v2/trades`;

export const STORE_MANAGEMENT = `${K8S_BASE_URL}/merch/stores/api/v1/store-management`;

export const LAT_LNG_FROM_ADDRESS =
  'https://nominatim.openstreetmap.org/search';

export const GET_ACTIVATION_PROFILE_WITH_TOKEN = `${APIK_BASE_URL}/ca/accountactivationapi/api/v2/accountactivation/fetchMinProfile`;

export const NEW_CAR_CONFIGURATION = `${K8S_BASE_URL}/merch/search/api/v2/newcarconfiguration`;
